/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanResponse } from '../../models/boolean-response';

export interface DeleteProfileCertification$Params {

/**
 * Profile id.
 */
  id: number;

/**
 * Profile certification type (ProfileCertificationType).
 */
  type: string;

/**
 * Profile certification year.
 */
  year: number;
}

export function deleteProfileCertification(http: HttpClient, rootUrl: string, params: DeleteProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteProfileCertification.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
    rb.path('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanResponse>;
    })
  );
}

deleteProfileCertification.PATH = '/rest/profile/{id}/certification/{type}/{year}';
